// THIS FILE IS AUTO-GENERATED BY "@udemy-v2/nextjs-pagekeys"
// DO NOT EDIT THIS FILE DIRECTLY. ENTRIES ARE ORDERED BY ROUTE SPECIFICITY (static > dynamic > catch-all).
// Reason: Consumers (Next.js headers/rewrites and getPageKeyForPathname) use first-match semantics, so specific
// routes must appear before generic catch-alls to avoid shadowing (e.g., 404 capturing all).

import { PageKeyDefinition } from '@udemy-v2/nextjs-pagekeys';

export const pageKeyDefinitions: PageKeyDefinition[] = [
    {
        pageKey: "example_isr_page",
        routePattern: "{/frontends-course-landing-page}{/:lang}/examples/isr-page/",
        routePatternNextJS: "/:lang/examples/isr-page/",
        filePath: "src/app/[lang]/examples/isr-page/page.tsx"
    },
    {
        pageKey: "example_sentry_page",
        routePattern: "{/frontends-course-landing-page}{/:lang}/examples/sentry-example-page/",
        routePatternNextJS: "/:lang/examples/sentry-example-page/",
        filePath: "src/app/[lang]/examples/sentry-example-page/page.tsx"
    },
    {
        pageKey: "example_ssr_page",
        routePattern: "{/frontends-course-landing-page}{/:lang}/examples/ssr-page/",
        routePatternNextJS: "/:lang/examples/ssr-page/",
        filePath: "src/app/[lang]/examples/ssr-page/page.tsx"
    },
    {
        pageKey: "examples_page",
        routePattern: "{/frontends-course-landing-page}{/:lang}/examples/",
        routePatternNextJS: "/:lang/examples/",
        filePath: "src/app/[lang]/examples/page.tsx"
    },
    {
        pageKey: "welcome",
        routePattern: "{/frontends-course-landing-page}{/:lang}/",
        routePatternNextJS: "/:lang/",
        filePath: "src/app/[lang]/page.tsx"
    },
    {
        pageKey: "course_landing_page",
        routePattern: "{/frontends-course-landing-page}{/:lang}/course/:courseLandingPath/",
        routePatternNextJS: "/:lang/course/:courseLandingPath/",
        filePath: "src/app/[lang]/course/[courseLandingPath]/page.tsx"
    },
    {
        pageKey: "example_buggy_page",
        routePattern: "{/frontends-course-landing-page}{/:lang}/examples/buggy-page/{/*slug}/",
        routePatternNextJS: "/:lang/examples/buggy-page/:slug*/",
        filePath: "src/app/[lang]/examples/buggy-page/[[...slug]]/page.tsx"
    },
    {
        pageKey: "404",
        routePattern: "{/frontends-course-landing-page}{/:lang}/*notFound/",
        routePatternNextJS: "/:lang/:notFound*/",
        filePath: "src/app/[lang]/[...notFound]/page.tsx"
    }
];
